import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '~/state'
import useIsWindowVisible from '~/hooks/useIsWindowVisible'
import useActiveWeb3React from '~/hooks/useActiveWeb3React'
// import { simpleRpcProvider } from '~/utils/providers'
import { setBlock } from '.'
import { State } from '../types'
import {useBlockNumber} from "wagmi";



export const usePollBlockNumber = (refreshTime = 6000) => {
  const timer = useRef(null)
  const dispatch = useAppDispatch()
  const isWindowVisible = useIsWindowVisible()
  const { client, chainId } = useActiveWeb3React()

  const { data: blockNumber, isError, isLoading } = useBlockNumber()

  useEffect(() => {
    if (isWindowVisible) {
      timer.current = setInterval(async () => {
        // const blockNumber = await simpleRpcProvider.getBlockNumber()
        // const block = await simpleRpcProvider.getBlock("latest");
        alert('here')
        // @ts-ignore
        client.getBlock(blockNumber)
        // const {number, timestamp}  = await client.getBlock("latest"); // await simpleRpcProvider.getBlock("latest");

        // dispatch(setBlock({number, timestamp}))
      }, refreshTime)
    } else {
      clearInterval(timer.current)
    }

    return () => clearInterval(timer.current)
  }, [dispatch, timer, isWindowVisible, refreshTime, blockNumber])
}

export const useBlock = () => {
  return useSelector((state: State) => state.block)
}

export const useInitialBlock = () => {
  return useSelector((state: State) => state.block.initialBlock)
}
